import * as MoneySum from "./MoneySum"
export const capitalize = window._ ? _.capitalize : (s => s)

export const config = {
  get currency() {
    return st.currency
  },

  get MONEY_BANK_RATES() {
    return st.MONEY_BANK_RATES
  }
}

export function encodeURIParams(params) {
  return Object.keys(params)
    .map(k => {
      const v = params[k]
      return v !== undefined && v !== null ? `${encodeURIComponent(k)}=${encodeURIComponent(v)}` : null
    })
    .filter(v => v !== null)
    .join("&")
}

export const domUtils = {
  isElementInViewport(el) {
    const rect = el.getBoundingClientRect();
    return rect.bottom >= 0 && rect.right >= 0 && rect.top <= (window.innerHeight || document.documentElement.clientHeight) && rect.left <= (window.innerWidth || document.documentElement.clientWidth);
  },

  isElementFullyInViewport(el) {
    const rect = el.getBoundingClientRect();
    return rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && rect.right <= (window.innerWidth || document.documentElement.clientWidth);
  }
}

export function formatMoney(amount, transactionAmount = null) {
  if (amount == null) { return }
  if (transactionAmount && !MoneySum.isEqual(Array.isArray(amount) ? amount : [amount], Array.isArray(transactionAmount) ? transactionAmount : [transactionAmount])) {
    const am = formatMoney(amount)
    const tAm = formatMoney(transactionAmount)
    return tAm ? `${am} (${tAm})` : am
  }
  if (amount.length != null) {
    return amount
      .map(a => formatMoney(a))
      .join(" + ")
  }

  let { value, currency } = amount
  value = Math.round(value * 100) / 100
  const sign = value >= 0 ? "" : "-"
  const units = ~~Math.abs(value)
  let cents = Math.round(100 * Math.abs(value)) % 100
  if (0 < cents && cents < 10) { cents = `0${cents}` }
  const number = cents > 0
    ? `${units},${cents}`
    : units

  let currencySymbol = currency
  if (currency === "PLN" && I18n.locale === "pl") { currencySymbol = "zł" }
  if (currency === "USD") { currencySymbol = "$" }
  if (currency === "EUR") { currencySymbol = "€" }
  return `${sign}${number} ${currencySymbol}`
}

export function exchangeMoney(money, otherCurrency, date = new Date()) {
  // return money
  if (money.length != null) {
    const value = money
      .map(m => exchangeMoney(m, otherCurrency, date))
      .reduce(((memo, m) => memo + m.value), 0)
    return { value, currency: otherCurrency }
  }

  if (money == null) { return }
  if (money.currency === otherCurrency) { return money }

  const rateKey = `${money.currency}_TO_${otherCurrency}`
  const rate = config.MONEY_BANK_RATES[rateKey]
  if (rate == null) {
    throw new Error(`exchangeMoney not possible: config.MONEY_BANK_RATES[${rateKey}] is undefined`)
  }

  return {
    value: money.value * rate,
    currency: otherCurrency
  }
};

export function formatDateRange(startDate, endDate) {
  return _([startDate, endDate])
    .compact()
    .map(date => formatDate(date))
    .uniq()
    .value()
    .join(" - ");
}

export function formatTimeRange(startsAt, endsAt, options = {}) {
  const {
    includeTime = true,
    includeDate = true
  } = options

  if (!includeTime) {
    return formatDateRange(startsAt, endsAt);
  }

  if (!includeDate || !endsAt || formatDate(startsAt, {format: "short"}) === formatDate(endsAt, {format: "short"})) {
    const time = _([startsAt, endsAt])
      .compact()
      .map(time => formatTime(time, {format: "time"}))
      .uniq()
      .value()
      .join(" - ");

    return includeDate ? [
      formatDateRange(startsAt, endsAt),
      time
    ].join(" ") : time;
  }

  return _([startsAt, endsAt])
    .compact()
    .uniq()
    .map(time => formatTime(time))
    .value()
    .join(" - ");
}

export function formatTimeDuration(timeDuration) {
  return moment.duration(timeDuration * 1000).humanize();
}

export function roundPrice(value) {
  if (!value || value <= 0) { return value; }
  return (Math.round(value * 100)) / 100;
};

export function formatTime(date, options = {}) {
  const {
    format = "long",
    includeTime = true,
    localZone = false,
  } = options

  if (!includeTime) {
    return formatDate(date, options)
  }

  const m = localZone || date.length <= 10 ? moment : moment.parseZone
  switch (format) {
    case "long":
      return capitalize(m(date).format("dddd, D MMMM YYYY [o] HH:mm"));
    case "medium":
      return capitalize(m(date).format("D MMMM YYYY [o] HH:mm"));
    case "short":
      return capitalize(m(date).format("DD-MM-YYYY HH:mm"));
    case "time":
      return capitalize(m(date).format(moment.TIME_FORMAT));
    default:
      return capitalize(m(date).format(format));
  }
};

export function formatDate(date, options = {}) {
  const {
    format = "long",
    localZone = false,
  } = options

  const m = localZone || date.length <= 10 ? moment : moment.parseZone
  switch (format) {
    case "long":
      return capitalize(m(date).format("dddd, D MMMM YYYY"));
    case "short":
      return capitalize(m(date).format("DD-MM-YYYY"));
    default:
      return capitalize(m(date).format(format));
  }
};

export function generateUuid() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    var r = Math.random()*16|0, v = c == 'x' ? r : (r&0x3|0x8);
    return v.toString(16);
  });
}

export const Media = {
  XXS_MIN: 320,
  XXS_MAX: 480 - 1,
  XS_MIN: 480,
  XS_MAX: 768 - 1,
  SM_MIN: 768,
  SM_MAX: 992 - 1,
  MD_MIN: 992,
  MD_MAX: 1200 - 1,
  LG_MIN: 1200,
  LG_MAX: null,

  // f.e. Media.isMin("md")
  isMin(size, width = $(window).width()) {
    return width >= Media[`${size.toUpperCase()}_MIN`];
  },

  isMax(size, width = $(window).width()) {
    return width <= Media[`${size.toUpperCase()}_MAX`];
  }
};

export function getQueryParam(name, search = window.location.search) {
  const q = search.match(new RegExp('[?&]' + name + '=([^&#]*)'))
  return q && q[1]
}

export function addQueryParamsToUrl(url, params = {}) {
  const encodedParams = encodeURIParams(params)
  if (encodedParams) {
    const [urlWithoutAnchor, anchor] = url.split("#")
    if (urlWithoutAnchor.indexOf("?") !== -1) {
      url = `${urlWithoutAnchor}&${encodedParams}${anchor ? "#" + anchor : ""}`
    } else {
      url = `${urlWithoutAnchor}?${encodedParams}${anchor ? "#" + anchor : ""}`
    }
  }
  return url
}

export function urlWithCurrentQuery(url) {
  const _iframe = (!getQueryParam("_iframe", url) && getQueryParam("_iframe")) || undefined
  const aid = (!getQueryParam("aid", url) && getQueryParam("aid")) || undefined
  return addQueryParamsToUrl(url, { _iframe, aid })
}



// WEBPACK FOOTER //
// ./app/webpack/shared/utils/socialtravel.js